<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-4">
      <form @submit.prevent="validateForm_Question">
        <div class="row">
          <div class="col-lg-4 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Tipo de Pregunta</label>
              <select
                class="form-select form-control h-45"
                aria-label="Default select example"
                v-model="question.questionTypeId"
                @change="clearError('questionTypeId')"
              >
                <option :value="null">-- Seleccionar --</option>
                <option
                  :value="item.id"
                  v-for="(item, i) of itemsQuestionTypes"
                  :key="i"
                >
                  {{ item.name }}
                </option>
              </select>
              <div class="input-error">{{ errors.questionTypeId }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary"
                >Enunciado de la Pregunta</label
              >
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar el enunciado de la pregunta"
                v-model="question.sentence"
                @input="clearError('sentence')"
              />
              <div class="input-error">{{ errors.sentence }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Descripción</label>
              <TextEditor
                @input="clearError('description')"
                class="text-editor"
                v-model="question.description"
                :placeholder="'Ingrese el contenido'"
              />

              <div class="input-error">{{ errors.description }}</div>
            </div>
          </div>
        </div>
        <div
          class="row"
          v-if="question.questionTypeId == QUESTION_TYPE.SEMIOPEN"
        >
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Respuesta</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar la respuesta correcta"
                v-model="question.answer"
                @input="clearError('answer')"
              />
              <div class="input-error">{{ errors.answer }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Pista</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder="Ingresar una pista"
                v-model="question.hint"
                @input="clearError('hint')"
              />
              <div class="input-error">{{ errors.hint }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Reintentos</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder=""
                v-model="question.retries"
                @input="
                  handleQuestionInput($event, 'retries');
                  clearError('retries');
                "
                maxlength="2"
              />
              <div class="input-error">{{ errors.retries }}</div>
            </div>
          </div>
          <div class="col-lg-2 col-sm-6">
            <div class="form-group mb-4">
              <label class="label text-secondary">Puntos bonus</label>
              <input
                type="text"
                class="form-control h-45"
                placeholder=""
                v-model="question.bonusPoints"
                @input="
                  handleQuestionInput($event, 'bonusPoints');
                  clearError('bonusPoints');
                "
                maxlength="3"
              />
              <div class="input-error">{{ errors.bonusPoints }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-2">
            <div class="form-group mb-4">
              <label class="label text-secondary strong"
                >Tipo de Multimedia</label
              >
              <select
                v-model="question.multimediaTypeId"
                @change.prevent="
                  setMultimediaTypeContent(question.multimediaTypeId)
                "
                class="form-select form-control h-45"
                aria-label="Default select example"
              >
                <option :value="null">{{ LABELS.SELECT }}</option>
                <option
                  v-for="option in multimediaOptions"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
              <div class="input-error">{{ errors.multimediaTypeId }}</div>
            </div>
          </div>
          <div class="col-lg-12" v-if="question.multimediaTypeId != null">
            <div class="form-group mb-4">
              <label class="label text-secondary">Multimedia</label>
              <FilePond
                v-show="question.multimediaTypeId != MULTIMEDIA_TYPES.LINK"
                ref="filePondRefQuestion"
                style="margin-bottom: -12px important!"
                name="fileMultimedia"
                :maxFileSize="'2MB'"
                :accepted-file-types="supportedFormats"
                allow-multiple="false"
                :max-files="1"
                label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
                :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
                :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
                :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
                :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormats.join(
                  ', '
                )}`"
                credits=""
                @updatefiles="handleUpdateFiles"
                @removefile="handleRemoveFile"
                @input="clearError('fileMultimedia')"
                v-if="!question.urlMultimedia"
              />
              <div class="input-error">{{ errors.fileMultimedia }}</div>
            </div>
            <div v-show="question.multimediaTypeId == MULTIMEDIA_TYPES.LINK">
              <div class="form-group mb-4">
                <label class="label text-secondary">Link</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingrese el link"
                  v-model="question.link"
                  @input="clearError('link')"
                />
                <div class="input-error">{{ errors.link }}</div>
              </div>
              <div class="form-group mb-4">
                <label class="label text-secondary">Texto del Link</label>
                <input
                  type="text"
                  class="form-control h-45"
                  placeholder="Ingrese el texto del link"
                  v-model="question.steps"
                  @input="clearError('steps')"
                />
                <div class="input-error">{{ errors.steps }}</div>
              </div>
            </div>
            <div>
              <div
                v-if="
                  question.urlMultimedia &&
                  question.multimediaTypeId == MULTIMEDIA_TYPES.IMAGE
                "
              >
                <img
                  :src="question.urlMultimedia"
                  alt="Multimedia"
                  class="img-fluid mb-2 d-block"
                />
              </div>
              <video
                v-if="videoBlobUrlQuestion"
                :src="videoBlobUrlQuestion"
                controls
                width="270"
              ></video>
              <audio
                v-if="audioUrlQuestion"
                :src="audioUrlQuestion"
                controls
                style="margin-top: 1rem"
              ></audio>
              <iframe
                v-if="pdfUrlQuestion"
                :src="pdfUrlQuestion"
                width="100%"
                height="700px"
              ></iframe>
            </div>
            <button
              @click.prevent="removeMultimediaFile"
              class="btn btn-danger"
            >
              Eliminar multimedia
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div
              class="card bg-white border-0 rounded-3 mb-4 mt-4"
              v-if="question.questionTypeId == QUESTION_TYPE.CLOSED"
            >
              <h4 class="fs-18 mb-4">Respuestas</h4>
              <div class="row">
                <div class="col-lg-10 col-sm-6">
                  <div class="form-group mb-4">
                    <div class="input-group h-45">
                      <input
                        maxlength="5000"
                        ref="questionInput"
                        type="text"
                        class="form-control"
                        placeholder="Ingresar la respuesta"
                        v-model="questionOptionText"
                        @keydown.enter.prevent="addQuestionOption"
                      />
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="addQuestionOption"
                      >
                        Agregar
                      </button>
                    </div>
                    <div class="input-error">
                      {{ errors.questionOptionText }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-error">{{ errors.questionOptions }}</div>
              <ul
                class="ps-0 mb-0 list-unstyled o-sortable cursor-move list-group"
                @dragover.prevent
                @drop="drop"
              >
                <li
                  v-for="(drag, index) in questionOptions"
                  :key="drag.id"
                  @dragstart="dragStart(index)"
                  @dragend="dragEnd()"
                  @dragover.prevent
                  @drop="dragDrop(index)"
                  draggable="true"
                  :class="[
                    'p-2 ps-3 rounded-2  d-flex align-items-center justify-content-between list-group-item list-group-item-primary bg-transparent text-primary',
                  ]"
                >
                  <!-- LEFT SIDE -->
                  <div class="d-flex align-items-center form-check">
                    <input
                      type="checkbox"
                      v-model="drag.isCorrect"
                      class="form-check-input me-3 mt-0"
                    />

                    <!-- Inline edit -->
                    <div
                      v-if="drag.isEditing"
                      class="d-flex align-items-center"
                    >
                      <input
                        type="text"
                        v-model="drag.option"
                        class="form-control form-control-sm h-45 me-2"
                        style="width: 710px; height: 36px"
                      />
                      <button
                        class="btn btn-sm btn-success text-success bg-transparent me-1 pb-0"
                        @click="saveOption(index)"
                        title="Guardar"
                      >
                        <span class="material-symbols-outlined fw-bold"
                          >check</span
                        >
                      </button>
                      <button
                        class="btn btn-sm btn-danger text-danger bg-transparent pb-0"
                        @click="cancelEdit(index)"
                        title="Cancelar"
                      >
                        <span class="material-symbols-outlined fw-bold"
                          >close</span
                        >
                      </button>
                    </div>

                    <!-- Normal view -->
                    <span v-else :class="['fs-13 fw-semibold']">
                      {{ drag.option }}
                    </span>
                  </div>

                  <!-- RIGHT SIDE: Buttons -->
                  <div class="d-flex align-items-center" v-if="!drag.isEditing">
                    <button
                      type="button"
                      class="btn btn-sm btn-default"
                      :class="{
                        'text-success': drag.multimediaTypeId != null,
                        'text-primary': drag.multimediaTypeId == null,
                      }"
                      @click="editFile(index)"
                      title="Agregar multimedia"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >music_note_add</span
                      >
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-default text-primary"
                      @click="editOption(index)"
                      title="Editar"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >edit</span
                      >
                    </button>

                    <button
                      type="button"
                      class="btn btn-sm btn-default text-primary"
                      @click="removeQuestionOption(index)"
                      title="Eliminar"
                    >
                      <span class="material-symbols-outlined menu-icon me-0"
                        >delete</span
                      >
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-4">
            <div class="d-flex flex-wrap gap-3">
              <RouterLink :to="`/questions`">
                <button
                  type="button"
                  class="btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                >
                  Cancelar
                </button>
              </RouterLink>
              <button
                class="btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4"
                type="submit"
                :disabled="isLoading"
              >
                <span v-if="!isLoading">{{
                  question.id == 0 ? "Crear Pregunta" : "Actualizar Pregunta"
                }}</span>
                <span
                  class="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                  v-if="isLoading"
                ></span>
                <span role="status" v-if="isLoading">Procesando...</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Modal -->
  <div
    id="mdlFileUpload"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="mdlFileUploadLabel"
    aria-hidden="true"
    size="large"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="mdlFileUploadLabel">
            Jugada - Archivo
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-8">
              <div class="form-group mb-4" v-if="questionOptionEdit">
                <label class="label text-secondary strong"
                  >Tipo de Multimedia</label
                >
                <select
                  v-model="questionOptionEdit.multimediaTypeId"
                  @change.prevent="
                    setMultimediaTypeQuestionOptionContent(
                      questionOptionEdit.multimediaTypeId
                    )
                  "
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT }}</option>
                  <option :value="MULTIMEDIA_TYPES.IMAGE">
                    {{ multimediaOptions[MULTIMEDIA_TYPES.IMAGE - 1].label }}
                  </option>
                  <option :value="MULTIMEDIA_TYPES.AUDIO">
                    {{ multimediaOptions[MULTIMEDIA_TYPES.AUDIO - 1].label }}
                  </option>
                </select>
                <div class="input-error">{{ errors.multimediaTypeId }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <FilePond
              ref="filePondRefAction"
              name="multimedia"
              :maxFileSize="'2MB'"
              :accepted-file-types="supportedFormatsModal"
              allow-multiple="false"
              :max-files="1"
              label-idle="Arrastra tu archivo o <span class='filepond--label-action'>Buscar</span>"
              :labelMaxFileSizeExceeded="'El archivo es demasiado grande'"
              :labelMaxFileSize="'El tamaño máximo permitido es {filesize}'"
              :labelFileTypeNotAllowed="'El archivo tiene una extensión no permitida'"
              :fileValidateTypeLabelExpectedTypes="`Los tipos de archivo permitidos son: ${supportedFormatsModal.join(
                ', '
              )}`"
              credits=""
              @removefile="handleRemoveFileModal"
              v-if="!questionOptionEdit?.urlMultimediaBlob"
            />
            <div v-if="questionOptionEdit">
              <div
                v-if="
                  questionOptionEdit.multimediaTypeId ==
                    MULTIMEDIA_TYPES.IMAGE &&
                  questionOptionEdit?.urlMultimediaBlob
                "
              >
                <img
                  :src="questionOptionEdit?.urlMultimediaBlob"
                  alt="Multimedia"
                  class="img-fluid mb-2 d-block"
                  style="width: 50%"
                />
              </div>
              <audio
                v-if="
                  questionOptionEdit.multimediaTypeId ==
                    MULTIMEDIA_TYPES.AUDIO &&
                  questionOptionEdit?.urlMultimediaBlob
                "
                :src="questionOptionEdit?.urlMultimediaBlob"
                controls
                style="margin-top: 1rem"
              ></audio>
            </div>
            <div class="col-lg-5">
              <button
                @click.prevent="removeMultimediaFileModal"
                v-if="questionOptionEdit?.urlMultimediaBlob"
                class="btn btn-danger"
              >
                Eliminar multimedia
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger text-white"
            @click="closeModalFile"
          >
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  playTypeRead_Schema,
  playTypeQuestion_Schema,
  questionOption_Schema,
} from "@/schemas/questionSchema";
import { defineComponent, ref, onMounted, computed } from "vue";
import api from "@/services/api";
import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";

import "@vuepic/vue-datepicker/dist/main.css";
import vueFilePond from "vue-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
//import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
//import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';

import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";

import type { FilePond as FilePondInstance } from "filepond";

import { es } from "date-fns/locale";
import {
  LABELS,
  MULTIMEDIA_TYPES,
  PLAY_TYPES,
  QUESTION_TYPE,
} from "@/utils/constants";
import TextEditor from "@/components/Common/TextEditor.vue";
import { allowOnlyNumbers } from "@/utils";
import Swal from "sweetalert2";

// Create FilePond component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview,
  FilePondPluginFilePoster
);
interface QuestionOption {
  id: number;
  option: string | null;
  isCorrect: boolean;
  isEditing: boolean;
  multimedia: null;
  multimediaTypeId: null;
  urlMultimedia: string | null;
  urlMultimediaBlob: any | null;
}

export default defineComponent({
  name: "CreateQuestion",
  components: { FilePond, TextEditor },

  setup() {
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const isLoading = ref(false);

    const itemsQuestionTypes = ref<any[]>([]);

    const initialPlayType = {
      id: 0,
      description: "",
      multimediaTypeId: null,
      fileMultimedia: null,
      urlMultimedia: null,
      link: null,
      playId: null,
      flagUploadContent: false,
      steps: null,
    };
    const playType = ref({ ...initialPlayType });

    const initialQuestion = {
      id: 0,
      questionTypeId: null,
      sentence: null,
      hint: null,
      retries: 0,
      bonusPoints: null,
      multimediaTypeId: null,
      fileMultimedia: null,
      urlMultimedia: null,
      link: null,
      playId: null,
      description: "",
      answer: null,
    };
    const question = ref<Record<string, any>>({ ...initialQuestion });

    const errors = ref<Record<string, string>>({});
    const questionInput = ref<HTMLInputElement | null>(null);
    const filePondRef = ref<FilePondInstance | null>(null);
    const filePondRefQuestion = ref<FilePondInstance | null>(null);
    const filePondRefAction = ref<FilePondInstance | null>(null);

    const supportedFormatsImage = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "image/gif",
    ];
    const supportedFormatsVideo = ["video/mp4"];
    const supportedFormatsFile = [
      "image/jpg",
      "image/jpeg",
      "image/png",
      "application/pdf",
    ];
    const supportedFormatsAudio = [
      "audio/mp3",
      "audio/mpeg",
      "audio/ogg",
      "audio/vnd.wav",
      "audio/mp4",
    ];
    const supportedFormats = ref([...supportedFormatsImage]);
    const supportedFormatsModal = ref([...supportedFormatsAudio]);
    const videoBlobUrl = ref<string | null>(null);
    const videoBlobUrlQuestion = ref<string | null>(null);
    const audioUrl = ref<string | null>(null);
    const audioUrlQuestion = ref<string | null>(null);
    const pdfUrl = ref<string | null>(null);
    const pdfUrlQuestion = ref<string | null>(null);
    const questionOptionText = ref<string | null>(null);
    const questionOptions = ref<QuestionOption[]>([]);
    const questionOptionEdit = ref<QuestionOption>();

    const modalFileUpload = ref<any>(null);

    onMounted(async () => {
      await getQuestionTypes();
      var idQuestion = route.params.id;
      if (idQuestion != null) {
        await getQuestionById(idQuestion);
      }

      const modalFileUploadElem = document.getElementById("mdlFileUpload");
      if (modalFileUploadElem && window.bootstrap) {
        modalFileUpload.value = new window.bootstrap.Modal(modalFileUploadElem);
        modalFileUpload.value.hide();
      }
    });

    const handleUpdateFiles = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        question.value.fileMultimedia = fileItems.length
          ? fileItems[0].file
          : null;

        const file = fileItems[0]?.file;
        if (file && file.type.startsWith("video/")) {
          videoBlobUrlQuestion.value = URL.createObjectURL(file);
        } else if (file && file.type.startsWith("audio/")) {
          audioUrlQuestion.value = URL.createObjectURL(file);
        } else if (file && file.type === "application/pdf") {
          pdfUrlQuestion.value = URL.createObjectURL(file);
        } else {
          videoBlobUrlQuestion.value = null;
          audioUrlQuestion.value = null;
          pdfUrlQuestion.value = null;
        }
      }
    };

    const handleRemoveFile = () => {
      question.value.urlMultimedia = null;
      question.value.fileMultimedia = null;
      if (question.value.multimediaTypeId == MULTIMEDIA_TYPES.VIDEO) {
        videoBlobUrlQuestion.value = null;
      } else if (
        question.value.multimediaTypeId == (MULTIMEDIA_TYPES.AUDIO as number)
      ) {
        audioUrlQuestion.value = null;
      } else if (
        question.value.multimediaTypeId == (MULTIMEDIA_TYPES.FILE as number)
      ) {
        pdfUrlQuestion.value = null;
      }
    };

    const validateForm_Content = async () => {
      try {
        errors.value = {};
        await playTypeRead_Schema(supportedFormats.value).validate(
          playType.value,
          { abortEarly: false }
        );
        isLoading.value = true;

        await createPlayType();
        isLoading.value = false;
      } catch (err: any) {
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const clearError = (field: string) => {
      errors.value[field] = "";
    };

    const buildFormData = (data: any) => {
      const formData = new FormData();
      for (const key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          key != "createdBy"
        ) {
          formData.append(key, data[key]);
        }
      }
      return formData;
    };

    const getQuestionById = async (id: any) => {
      try {
        const response = await api.get(`/question/${id}`);
        const responseFormat = response.data;
        if (responseFormat.urlMultimedia) {
          responseFormat.urlMultimedia =
            process.env.VUE_APP_API_URL + "/" + responseFormat.urlMultimedia;
        }

        question.value = responseFormat;
        questionOptions.value = responseFormat.options;
        question.value.options = null;

        if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.VIDEO) {
          videoBlobUrlQuestion.value = responseFormat.urlMultimedia;
        } else if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO) {
          audioUrlQuestion.value = responseFormat.urlMultimedia;
        } else if (responseFormat.multimediaTypeId == MULTIMEDIA_TYPES.FILE) {
          pdfUrlQuestion.value = responseFormat.urlMultimedia;
        }

        questionOptions.value.forEach((element) => {
          if (element.urlMultimedia != null) {
            element.urlMultimedia =
              process.env.VUE_APP_API_URL + "/" + element.urlMultimedia;
            element.urlMultimediaBlob = element.urlMultimedia;
          }
        });
      } catch (ex) {
        console.error(ex);
      }
    };

    const createPlayType = async () => {
      try {
        let response: any;
        const formDataQuestion = buildFormData(question.value);

        if (questionOptions.value != null && questionOptions.value.length > 0) {
          formDataQuestion.append(
            "options",
            JSON.stringify(
              questionOptions.value.map((o, i) => ({
                id: o.id,
                option: o.option,
                isCorrect: o.isCorrect,
                isEditing: o.isEditing,
                multimediaTypeId: o.multimediaTypeId,
                multimediaKey: o.multimedia ? `option_multimedia_${i}` : null, // track which file belongs to which
              }))
            )
          );

          // Append each file separately
          questionOptions.value.forEach((o, i) => {
            if (o.multimedia) {
              formDataQuestion.append(`option_multimedia_${i}`, o.multimedia);
            }
          });
        }

        if (question.value.questionTypeId == QUESTION_TYPE.SEMIOPEN) {
          formDataQuestion.append(
            "options",
            JSON.stringify([
              {
                id: 0,
                option: question.value.answer,
                isCorrect: true,
                isEditing: false,
                multimediaTypeId: null,
              },
            ])
          );
        }

        response = await api.postForm(`/question`, formDataQuestion);

        if (response.data.return) {
          toast.success(
            `La Pregunta fue ${
              playType.value.id == 0 ? "creada" : "actualizada"
            } con éxito.`,
            {
              timeout: 2000,
            }
          );
          router.push(`/questions`).catch((err) => {
            console.error("Navigation error:", err);
          });
        }
      } catch (ex) {
        toast.error("La pregunta no pudo ser creada.", {
          timeout: 2000,
        });
        console.error(ex);
      }
    };

    const removeMultimediaFile = async () => {
      question.value.urlMultimedia = null;

      clearVideoBlob();
      clearAudio();
      clearFile();
    };

    const multimediaOptions = computed(() =>
      Object.entries(MULTIMEDIA_TYPES).map(([key, value]) => ({
        label: key,
        value: value,
      }))
    );

    const setMultimediaTypeContent = (idMultimediaType: number | null) => {
      if (idMultimediaType) {
        question.value.urlMultimedia = null;
        question.value.fileMultimedia = null;
        if (filePondRefQuestion.value) {
          filePondRefQuestion.value?.removeFiles();
        }
        switch (idMultimediaType) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormats.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.VIDEO:
            supportedFormats.value = [...supportedFormatsVideo];
            break;
          case MULTIMEDIA_TYPES.FILE:
            supportedFormats.value = [...supportedFormatsFile];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormats.value = [...supportedFormatsAudio];
            break;
        }

        clearVideoBlob();
        clearAudio();
        clearFile();
      } else {
        question.value.fileMultimedia = null;
        question.value.urlMultimedia = null;
        if (filePondRefQuestion.value) {
          filePondRefQuestion.value?.removeFiles();
        }
        clearVideoBlob();
        clearAudio();
        clearFile();
      }
    };

    const clearVideoBlob = () => {
      if (videoBlobUrlQuestion.value) {
        URL.revokeObjectURL(videoBlobUrlQuestion.value);
        videoBlobUrlQuestion.value = null;
      }
    };

    const clearAudio = () => {
      if (audioUrlQuestion.value) {
        URL.revokeObjectURL(audioUrlQuestion.value);
        audioUrlQuestion.value = null;
      }
    };

    const clearFile = () => {
      if (pdfUrlQuestion.value) {
        URL.revokeObjectURL(pdfUrlQuestion.value);
        pdfUrlQuestion.value = null;
      }
    };

    const validateForm_Question = async () => {
      try {
        errors.value = {};

        if (!question.value.multimediaTypeId) {
          if (filePondRefQuestion.value) {
            filePondRefQuestion.value?.removeFiles();
            question.value.fileMultimedia = null;
          }
        }
        await playTypeQuestion_Schema(supportedFormats.value).validate(
          { ...question.value, questionOptions: questionOptions.value },
          { abortEarly: false }
        );
        isLoading.value = true;

        await createPlayType();
        isLoading.value = false;
      } catch (err: any) {
        console.log("err: " + err);
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
        isLoading.value = false;
      }
    };

    const getQuestionTypes = async () => {
      try {
        const response = await api.get(`/common/question-types`);
        itemsQuestionTypes.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };

    function handleQuestionInput(event: Event, field: string) {
      const target = event.target as HTMLInputElement;
      question.value[field] = allowOnlyNumbers(target.value);
    }

    const dragIndex = ref<number | null>(null);

    const dragStart = (index: number) => {
      dragIndex.value = index;
    };

    const dragEnd = () => {
      dragIndex.value = null;
    };

    const dragDrop = (targetIndex: number) => {
      if (dragIndex.value !== null && targetIndex !== dragIndex.value) {
        const [movedItem] = questionOptions.value.splice(dragIndex.value, 1);
        questionOptions.value.splice(targetIndex, 0, movedItem);
        dragIndex.value = null;
      }
    };

    const drop = (event: DragEvent) => {
      event.preventDefault();
    };

    const addQuestionOption = async () => {
      try {
        errors.value = {};

        await questionOption_Schema.validate(
          { questionOptionText: questionOptionText.value },
          { abortEarly: false }
        );

        questionOptions.value.push({
          id: 0,
          option: questionOptionText.value,
          isCorrect: false,
          isEditing: false,
          multimedia: null,
          multimediaTypeId: null,
          urlMultimedia: null,
          urlMultimediaBlob: null,
        });

        questionOptionText.value = null;
        questionInput.value?.focus();
      } catch (err: any) {
        if (err.inner) {
          err.inner.forEach((e: any) => {
            errors.value[e.path] = e.message;
          });
        }
      }
    };

    const editQuestionOption = async (index: number) => {
      questionOptions.value.splice(index, 1);
    };

    const editOption = async (index: number) => {
      questionOptions.value[index].isEditing = true;
    };
    const cancelEdit = async (index: number) => {
      questionOptions.value[index].isEditing = false;
    };
    const saveOption = async (index: number) => {
      // You can validate or call backend here if needed
      questionOptions.value[index].isEditing = false;
    };

    const editFile = async (index: number) => {
      questionOptionEdit.value = questionOptions.value[index];
      if (questionOptionEdit.value.multimediaTypeId) {
        switch (questionOptionEdit.value.multimediaTypeId) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormatsModal.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormatsModal.value = [...supportedFormatsAudio];
            if (filePondRefAction.value) {
              filePondRefAction.value?.removeFiles();
            }
            break;
        }
      }

      modalFileUpload.value.show();
    };

    const removeQuestionOption = async (index: number) => {
      questionOptions.value.splice(index, 1);
    };

    const handleUpdateFilesModal = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        if (questionOptionEdit.value) {
          if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            if (
              fileItems[0].file &&
              fileItems[0].file.type.startsWith("audio/")
            ) {
              questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
                fileItems[0].file
              );
            }
          }
        }
      }
    };

    const handleFilesModal = (fileItems: any[]) => {
      const validFiles = fileItems.filter((file) => file.status === 2); // FilePond status ID 2 = 'processed'
      if (validFiles && validFiles.length > 0) {
        if (questionOptionEdit.value) {
          if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.AUDIO
          ) {
            if (
              fileItems[0].file &&
              fileItems[0].file.type.startsWith("audio/")
            ) {
              questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
                fileItems[0].file
              );
            }
          } else if (
            questionOptionEdit.value.multimediaTypeId == MULTIMEDIA_TYPES.IMAGE
          ) {
            questionOptionEdit.value.urlMultimediaBlob = URL.createObjectURL(
              fileItems[0].file
            );
          }
          questionOptionEdit.value.multimedia = fileItems.length
            ? fileItems[0].file
            : null;
        }
      }
    };

    const handleRemoveFileModal = () => {
      if (questionOptionEdit.value) {
        questionOptionEdit.value.multimedia = null;
        questionOptionEdit.value.urlMultimedia = null;
        //questionOptionEdit.value.multimediaTypeId =  null;
        if (filePondRefAction.value) {
          filePondRefAction.value?.removeFiles();
        }
      }
      clearAudioModal();
    };

    const resetValues = async () => {
      Object.assign(question.value, initialQuestion);
      Object.assign(playType.value, initialPlayType);
      questionOptions.value = [];
      questionOptionText.value = null;
      videoBlobUrl.value = null;
      videoBlobUrlQuestion.value = null;
      audioUrl.value = null;
      audioUrlQuestion.value = null;
      pdfUrl.value = null;
      pdfUrlQuestion.value = null;
    };

    const setMultimediaTypeQuestionOptionContent = (
      idMultimediaType: number | null
    ) => {
      if (idMultimediaType) {
        if (questionOptionEdit.value) {
          questionOptionEdit.value.urlMultimedia = null;
          questionOptionEdit.value.multimedia = null;
          if (filePondRefAction.value) {
            filePondRefAction.value?.removeFiles();
          }
        }

        switch (idMultimediaType) {
          case MULTIMEDIA_TYPES.IMAGE:
            supportedFormatsModal.value = [...supportedFormatsImage];
            break;
          case MULTIMEDIA_TYPES.AUDIO:
            supportedFormatsModal.value = [...supportedFormatsAudio];
            break;
        }

        clearAudioModal();
      }
    };

    const clearAudioModal = () => {
      if (questionOptionEdit.value) {
        if (questionOptionEdit.value.urlMultimediaBlob) {
          URL.revokeObjectURL(questionOptionEdit.value.urlMultimediaBlob);
          questionOptionEdit.value.urlMultimediaBlob = null;
        }
      }
    };

    const removeMultimediaFileModal = async () => {
      if (filePondRefAction.value) {
        filePondRefAction.value?.removeFiles();
      }
      if (questionOptionEdit.value) {
        questionOptionEdit.value.urlMultimedia = null;
        questionOptionEdit.value.multimedia = null;
        //questionOptionEdit.value.multimediaTypeId = null
        clearAudioModal();
      }
    };

    const closeModalFile = () => {
      const files = filePondRefAction.value?.getFiles() || [];
      console.log("files: " + files);
      if (files.length > 0) {
        handleFilesModal(files);
      } else {
        if (
          questionOptionEdit.value &&
          questionOptionEdit.value.urlMultimediaBlob == null
        ) {
          questionOptionEdit.value.multimediaTypeId = null;
        }
      }

      if (filePondRefAction.value) {
        filePondRefAction.value?.removeFiles();
      }

      modalFileUpload.value.hide();
    };

    return {
      itemsQuestionTypes,
      PLAY_TYPES,
      handleUpdateFiles,
      createPlayType,
      validateForm_Content,
      clearError,
      removeMultimediaFile,
      handleRemoveFile,
      setMultimediaTypeContent,
      LABELS,
      MULTIMEDIA_TYPES,
      QUESTION_TYPE,
      playType,
      errors,
      isLoading,
      es,
      supportedFormats,
      supportedFormatsModal,
      multimediaOptions,
      filePondRef,
      videoBlobUrl,
      videoBlobUrlQuestion,
      audioUrl,
      audioUrlQuestion,
      pdfUrl,
      pdfUrlQuestion,
      validateForm_Question,
      filePondRefQuestion,
      question,
      handleQuestionInput,
      removeQuestionOption,
      addQuestionOption,
      editQuestionOption,
      editOption,
      cancelEdit,
      saveOption,
      questionOptionText,
      questionOptions,
      dragStart,
      dragEnd,
      dragDrop,
      drop,
      route,
      resetValues,
      editFile,
      questionOptionEdit,
      handleUpdateFilesModal,
      handleRemoveFileModal,
      filePondRefAction,
      setMultimediaTypeQuestionOptionContent,
      removeMultimediaFileModal,
      closeModalFile,
    };
  },
});
</script>
